import { useAppSelector } from 'reduxTyped'

import { getPermission } from 'common/userRoles'
import { PermissionTargets } from 'common/userRoles/constants/UserRoles'

export const usePermission = (target: PermissionTargets): boolean => {
  return useAppSelector((state) => getPermission(state, target))
}
